import { render, staticRenderFns } from "./ReviewPage.vue?vue&type=template&id=71555413&scoped=true&"
import script from "./ReviewPage.vue?vue&type=script&lang=ts&"
export * from "./ReviewPage.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewPage.vue?vue&type=style&index=0&id=71555413&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71555413",
  null
  
)

export default component.exports